import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import FadeInUp from "./FadeInUp";

const LandingCTA = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const t = (obj) => obj[lang] || obj.fr;

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: "#0f1011", borderTop: "1px solid #23252a" }}>
      <div className="max-w-4xl mx-auto">
        <FadeInUp>
          <div style={{ position: "relative" }}>
            {/* Ambient glow behind the card */}
            <div style={{
              position: "absolute",
              inset: 0,
              pointerEvents: "none",
              background: "radial-gradient(ellipse at 50% 50%, rgba(94,106,210,0.1) 0%, transparent 70%)",
              filter: "blur(40px)",
              transform: "scale(1.2)",
            }} />

            <div
              style={{
                position: "relative",
                backgroundColor: "#141516",
                borderRadius: "16px",
                padding: "clamp(32px, 6vw, 64px)",
                textAlign: "center",
                boxShadow: "0 0 0 1px rgba(94,106,210,0.3), 0 0 80px rgba(94,106,210,0.08)",
              }}
            >
              <h2
                style={{
                  color: "#f7f8f8",
                  fontSize: "clamp(24px, 4vw, 36px)",
                  fontWeight: 600,
                  lineHeight: 1.2,
                  letterSpacing: "-1.0px",
                  marginBottom: "16px",
                }}
              >
                {t({ fr: "Transformez votre gestion RH dès aujourd'hui", en: "Transform your HR management today", ar: "حوّل إدارة مواردك البشرية اليوم" })}
              </h2>
              <p
                style={{
                  color: "#8a8f98",
                  fontSize: "16px",
                  lineHeight: 1.5,
                  letterSpacing: "-0.05px",
                  maxWidth: "480px",
                  margin: "0 auto 32px",
                }}
              >
                {t({
                  fr: "14 jours d'essai gratuit, sans carte de crédit. Configurez votre compte en moins de 10 minutes.",
                  en: "14-day free trial, no credit card required. Set up your account in under 10 minutes.",
                  ar: "تجربة مجانية لمدة 14 يومًا، لا بطاقة ائتمان مطلوبة. أعدّ حسابك في أقل من 10 دقائق.",
                })}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <button
                  onClick={() => navigate("/register")}
                  className="inline-flex items-center justify-center gap-2 transition-all"
                  style={{
                    backgroundColor: "#5e6ad2",
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: 500,
                    padding: "10px 20px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    boxShadow: "0 0 20px rgba(94,106,210,0.3)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#828fff";
                    e.currentTarget.style.boxShadow = "0 0 30px rgba(130,143,255,0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#5e6ad2";
                    e.currentTarget.style.boxShadow = "0 0 20px rgba(94,106,210,0.3)";
                  }}
                >
                  {t({ fr: "Démarrer l'essai gratuit", en: "Start free trial", ar: "ابدأ التجربة المجانية" })}
                  <ArrowRight className="w-4 h-4" />
                </button>
                <button
                  onClick={() => {
                    const el = document.getElementById("contact");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="inline-flex items-center justify-center gap-2 transition-colors"
                  style={{
                    backgroundColor: "transparent",
                    color: "#d0d6e0",
                    fontSize: "14px",
                    fontWeight: 500,
                    padding: "10px 20px",
                    borderRadius: "8px",
                    border: "1px solid #34343a",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#3e3e44")}
                  onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#34343a")}
                >
                  {t({ fr: "Parler à un expert", en: "Talk to an expert", ar: "تحدّث مع خبير" })}
                </button>
              </div>
            </div>
          </div>
        </FadeInUp>
      </div>
    </section>
  );
};

export default LandingCTA;
